const type = 'advanced'
const path = '/advance/angular-node/angular/src/app/'
const name = 'app.module.ts'

export { type, path, name }
